import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { updateStockoutStatus } from '@/api/order.js';
export default {
  components: {},
  data: function data() {
    return {
      dialogTitle: '收货确认',
      dialogVisible: false,
      form: {
        id: null,
        checkState: 1
      },
      rows: [],
      loading: false
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    init: function init(rows) {
      var that = this;
      that.dialogVisible = true;
      that.loading = false;
      that.rows = rows;
      that.form = {
        checkState: 1
      };
    },
    dialogClose: function dialogClose() {
      var that = this;
      that.dialogVisible = false;
    },
    formSubmit: function formSubmit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;

                if (!(that.form.checkState === 1)) {
                  _context.next = 12;
                  break;
                }

                that.loading = true;
                _context.prev = 3;
                _context.next = 6;
                return that.updateStatusForm();

              case 6:
                _context.next = 10;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](3);

              case 10:
                _context.next = 13;
                break;

              case 12:
                that.dialogClose();

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 8]]);
      }))();
    },
    updateStatusForm: function updateStatusForm() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, form;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2;

                if (!(that.rows.length > 0)) {
                  _context2.next = 9;
                  break;
                }

                form = {
                  id: that.rows[0].ID,
                  status: 6
                };
                _context2.next = 5;
                return updateStockoutStatus(form);

              case 5:
                that.rows.shift();
                setTimeout(function () {
                  that.updateStatusForm();
                }, 500);
                _context2.next = 13;
                break;

              case 9:
                that.loading = false;
                that.$notify.success('收货确认成功');
                that.dialogClose();
                that.$emit('reload');

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};